import React from "react";

const ClientAddress = ({ client }) => {
  const hasAddress =
    client?.address1 ||
    client?.address2 ||
    client?.city ||
    client?.province ||
    client?.postalCode ||
    client?.country;

  if (!hasAddress) {
    return (
      <div className="gog-client-address gog-muted-block">
        No address available.
      </div>
    );
  }

  return (
    <address className="gog-client-address">
      {client.address1 && <strong>{client.address1}</strong>}

      {client.address2 && <span>{client.address2}</span>}

      {(client.city || client.province) && (
        <span>
          {[client.city, client.province].filter(Boolean).join(", ")}
        </span>
      )}

      {(client.postalCode || client.country) && (
        <span>
          {[client.postalCode, client.country].filter(Boolean).join(", ")}
        </span>
      )}
    </address>
  );
};

export default ClientAddress;